(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("locale/locale_it", [], factory);
	else if(typeof exports === 'object')
		exports["locale/locale_it"] = factory();
	else
		root["locale/locale_it"] = factory();
})(window, function() {
return 